import { createAction } from '@reduxjs/toolkit'

/** Перечитать журнал обмена продажи с кабинетом — только чтение своей базы службы (F05). */
export const saleExchangesReloadRequested = createAction<{ resourceId: string; saleId: string }>('aqsi/exchange/reloadRequested')
